import React from "react";
import { ShieldOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user?.role !== "admin" && user?.role !== "moderator") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAFAFB] px-4" data-testid="admin-access-denied">
        <div className="w-full max-w-sm rounded-3xl border border-slate-100 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100">
            <ShieldOff className="h-7 w-7 text-slate-400" />
          </div>
          <h1 className="font-heading text-xl font-extrabold text-slate-900">403 — Access denied</h1>
          <p className="mt-2 text-sm text-slate-500">This area is restricted to Yaprio moderators.</p>
          <Button
            onClick={() => navigate("/home")}
            data-testid="admin-denied-home-btn"
            className="mt-6 w-full rounded-full bg-pink-500 text-white hover:bg-pink-600"
          >
            Back to Home
          </Button>
        </div>
      </div>
    );
  }
  return children;
}
